import {
  addDays,
  subDays,
  subHours,
  format,
  startOfMonth,
  endOfMonth,
  subMonths,
} from "date-fns";

const formatDate = (date) => format(date, "yyyy-MM-dd");

const getShiftedDate = (daysToAdd = 0, hoursToSub = 0) => {
  return subHours(addDays(new Date(), daysToAdd), hoursToSub);
};

const loadPeriodOptions = () => [
  {
    key: 0,
    label: "Próximos 30 dias",
    startDate: `${formatDate(getShiftedDate(1, 6))} 00:00:00`,
    endDate: `${formatDate(getShiftedDate(30, 6))} 00:00:00`,
  },
  {
    key: 1,
    label: "Próximos 15 dias",
    startDate: `${formatDate(getShiftedDate(1, 6))} 00:00:00`,
    endDate: `${formatDate(getShiftedDate(15, 6))} 00:00:00`,
  },
  {
    key: 2,
    label: "Próximos 7 dias",
    startDate: `${formatDate(getShiftedDate(1, 6))} 00:00:00`,
    endDate: `${formatDate(getShiftedDate(7, 6))} 00:00:00`,
  },
  {
    key: 3,
    label: "Próximos 3 dias",
    startDate: `${formatDate(getShiftedDate(1, 6))} 00:00:00`,
    endDate: `${formatDate(getShiftedDate(3, 6))} 00:00:00`,
  },
  {
    key: 4,
    label: "Amanhã",
    startDate: `${formatDate(getShiftedDate(1, 6))} 00:00:00`,
    endDate: `${formatDate(getShiftedDate(2, 6))} 00:00:00`,
  },
  {
    key: 5,
    default: true,
    label: "Hoje",
    startDate: `${formatDate(subHours(new Date(), 6))} 00:00:00`,
    endDate: `${formatDate(getShiftedDate(1, 6))} 00:00:00`,
  },
  {
    key: 6,
    label: "Ontem",
    startDate: `${formatDate(subDays(new Date(), 1))} 00:00:00`,
    endDate: `${formatDate(addDays(new Date(), 1))} 00:00:00`,
  },
  {
    key: 7,
    label: "Últimos 2 dias",
    startDate: `${formatDate(subDays(new Date(), 2))} 00:00:00`,
    endDate: `${formatDate(addDays(new Date(), 1))} 00:00:00`,
  },
  {
    key: 8,
    label: "Últimos 3 dias",
    startDate: `${formatDate(subDays(new Date(), 3))} 00:00:00`,
    endDate: `${formatDate(addDays(new Date(), 1))} 00:00:00`,
  },
  {
    key: 9,
    label: "Últimos 7 dias",
    startDate: `${formatDate(subDays(new Date(), 7))} 00:00:00`,
    endDate: `${formatDate(addDays(new Date(), 1))} 00:00:00`,
  },
  {
    key: 10,
    label: "Últimos 15 dias",
    startDate: `${formatDate(subDays(new Date(), 15))} 00:00:00`,
    endDate: `${formatDate(addDays(new Date(), 1))} 00:00:00`,
  },
  {
    key: 11,
    label: "Últimos 30 dias",
    startDate: `${formatDate(subDays(new Date(), 30))} 00:00:00`,
    endDate: `${formatDate(addDays(new Date(), 1))} 00:00:00`,
  },
  {
    key: 12,
    label: "Mês anterior",
    startDate: `${formatDate(startOfMonth(subMonths(new Date(), 1)))} 00:00:00`,
    endDate: `${formatDate(endOfMonth(subMonths(new Date(), 1)))} 00:00:00`,
  },
  {
    key: 13,
    label: "Personalizado",
    startDate: `${formatDate(new Date())} 00:00:00`,
    endDate: `${formatDate(new Date())} 23:59:59`,
  },
];

export default loadPeriodOptions;
